function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 .4H8a.4.4 0 0 0-.36.225l-4 8.227-.017.043A.4.4 0 0 0 4 9.427h2.45l-1.83 5.647c-.135.417.401.716.685.383l6.999-8.227.026-.035A.4.4 0 0 0 12 6.57H8.735l3.599-5.553A.4.4 0 0 0 11.999.4zm-.737.8L7.664 6.753l-.022.038a.4.4 0 0 0 .358.58h3.134l-5.131 6.031L7.38 9.15l.012-.045A.4.4 0 0 0 7 8.627H4.64L8.25 1.2h3.013z",
  fill: "#1F2947",
  fillRule: "nonzero"
});
const SvgBonusIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBonusIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bonus-icon.c4a48b81.svg";
export { ForwardRef as ReactComponent };